//#region DevExtreme Imports

import 'devextreme/ui/button'

//#endregion

import { ItemSwapperController } from "./item-swapper.controller"
import { UserSessionService, USER_SESSION_SERVICE_NAME } from "../../../../services/user-session"
import { GridService, GRID_SERVICE_NAME } from "../../../../services/grid"

//#region Asset Imports

import './item-swapper.scss'
import * as TEMPLATE from './item-swapper.tpl.html'

//#endregion

// #region Consts

export const COMPONENT_NAME: string = 'itemSwapper'

// #endregion

// #region Setup


export class ItemSwapperComponent {

    controller = [
        '$scope',
        USER_SESSION_SERVICE_NAME,
        GRID_SERVICE_NAME,
        ($scope: ng.IScope, userSession: UserSessionService, gridService: GridService) => new ItemSwapperController($scope, userSession, gridService)
    ]

    restrict = 'E'

    bindings = {
        id: '<',
        options: '<'
    } as { [index: string]: string }

    template = TEMPLATE
}

// #endregion